var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgEraseOffFill = function SvgEraseOffFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.775 22.625 15.05 17.9 13 20H4.75l-2.125-2.125q-.575-.575-.587-1.425T2.6 15l4.7-4.85-5.925-5.925L2.8 2.8l18.4 18.4zm-1.9-7.6L10.1 7.25l3.5-3.65q.575-.6 1.412-.6.838 0 1.413.575L21.4 8.55q.575.575.575 1.425T21.4 11.4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEraseOffFill);
export { ForwardRef as ReactComponent };